import React, {SyntheticEvent, useEffect, useState} from "react";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import {
    AlertTypes,
    apiClient,
    enumNamesToSelect,
    Grid,
    Leap4Breadcrumbs,
    Mode,
    setAlert,
    MuiIcons,
    BaseCrudClient,
    GenericFormContainer,
    Spinner,
    Typography,
    TextField,
    Button,
    FormControl,
    Toc as TocIcon,
    Create as CreateIcon,
    GpsFixed as GpsFixedIcon
} from "@leap4/frontend";
// Logic.
import {useDispatch} from "react-redux";
import { styles } from "./style";
import {IPartner, PartnerSideEnum} from "@leap4/entities-discrepancy-common";
import {baseBackendRoute, partnersBaseUrl} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {useQuery} from "react-query";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../shared/OneOrgOnly/OneOrgOnly";

const {AutoFixNormal: AutoFixNormalIcon} = MuiIcons;


const {add, update, deleteInstance, getById} = BaseCrudClient;

interface IFormData extends Partial<IPartner> {
}

const AddEditPartner = (): JSX.Element => {
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const dispatch = useDispatch();

    const schemaName = "partner";
    const addInstanceRoute = `/${schemaName}s/add`;
    const editInstanceRoute = `/${schemaName}s/`;
    const PartnerSideSelect = enumNamesToSelect(PartnerSideEnum, undefined, undefined, 'Side')
    const [isAddPage, setIsAddPage] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);


    const [entity, setInstance] = useState<IFormData>({});


    const handleFormChange = (e: any) => {
        let {name, value} = e.target;
        setInstance({...entity, [name]: value});
    }

    const deleteFunc = async () => {
        setIsLoading(true)
        await deleteInstance(String(params.id), schemaName, history, dispatch, baseBackendRoute)
        setIsLoading(false);
    }

    const onDeletePartner = async () => {
        await apiClient.delete(`${partnersBaseUrl}/${params.id}`)
    }

    const {isLoading: isLoadingDelete, refetch: deletePartner} = useQuery(
        'assign-partner--query',
        onDeletePartner,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    const handleSubmit = async (ev: SyntheticEvent) => {
        // For block rendering.
        ev?.preventDefault();
        setIsLoading(true)
        if (!entity) {
            return;
        }


        if (isAddPage) {
            //TODO: Replace with dto type instead of any.
            await add<any>(entity, schemaName, history, dispatch, baseBackendRoute);
        } else if (params.id && params.id != "add") {
            //TODO: Replace with dto type instead of any.
            await update<any>(params.id, entity, schemaName, history, dispatch, baseBackendRoute);
        }

        setIsLoading(false)
    };


    // Init form.
    useEffect(() => {
        (async () => {
            setIsLoading(true);

            const id = params.id;
            // For edit page.

            if (id && id !== "add") {
                setIsAddPage(false);
                const instanceData = await getById(id, schemaName, dispatch, baseBackendRoute);
                setInstance({...instanceData});

            } else {
                setInstance({
                    name: "",
                })
            }

            setIsLoading(false);
        })()
    }, [params.id]);

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Leap4Breadcrumbs
                breadcrumbs={[
                    {
                        text: "Partners Dashboard",
                        icon: <TocIcon/>,
                        link: urlService.partnersDemand()
                    },
                    {
                        text: isAddPage ? "Create" : "Update",
                        link: isAddPage ? addInstanceRoute : editInstanceRoute,
                        icon: isAddPage ? <CreateIcon/> : <AutoFixNormalIcon/>
                    },
                    {
                        text: entity.name,
                        link: "",
                        icon: <GpsFixedIcon/>
                    }
                ]}
            />
            <GenericFormContainer mode={isAddPage ? Mode.Create : Mode.Edit}
                                  onCreateOrEditFunc={handleSubmit}
                                  disabled={isLoading || isLoadingDelete}
                                  style={{height: '400px', padding: '20px', margin: "35px 25px", borderRadius: "16px"}}
                                  onDeleteFunction={() => deletePartner()}>


                {isLoading || isLoadingDelete ? <Spinner/> : <form style={styles.form} noValidate onSubmit={handleSubmit}>
                    <Grid direction={"column"} container alignItems={"flex-start"}>
                        <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>

                                <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                                    {params.id ? 'Update' : 'Add'} Partner
                                </Typography>
                                {params.id && <Grid item>
                                    <RouterLink to={urlService.partnerOverview(params.id, true)}>
                                        <Button size="large" variant="contained" color="primary">
                                            TO OVERVIEW
                                        </Button>
                                    </RouterLink>
                                </Grid>}
                        </Grid>
                        <Grid item width={"50%"} marginTop={"2vh"}>
                            <TextField
                                disabled={isLoading || isLoadingDelete}
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Name"
                                name="name"
                                autoComplete="name"
                                autoFocus
                                onChange={handleFormChange}
                                value={entity?.name}
                            />
                            <FormControl variant="outlined" style={styles.formControl}>
                                <PartnerSideSelect
                                    label={'Side'}
                                    required
                                    fullWidth
                                    value={entity?.side}
                                    onChange={handleFormChange}
                                    name="side"/>
                            </FormControl>
                        </Grid>
                    </Grid>
                </form>}
            </GenericFormContainer>


        </>
    );
}

export default AddEditPartner;
